import { fontSize02, fontSize03 } from "./armor-system-JGP743DI.js";
import { __spreadProps, __spreadValues } from "./armor-system-JQVN7XCJ.js";

// src/theme/legacy/makeTypography.ts
var makeTypography = function makeTypography(theme) {
  var typography = theme.typography;
  var fontSize = typography.fontSize || fontSize02;
  var htmlFontSize = typography.htmlFontSize || fontSize03;
  var factor = fontSize / fontSize02;
  return __spreadProps(__spreadValues({}, typography), {
    fontFamily: typography.fontFamily || "Roboto, sans-serif",
    fontSize: fontSize,
    htmlFontSize: htmlFontSize,
    pixelToRem: function pixelToRem(size) {
      if (size === 0) {
        return "0";
      }
      if (typeof size === "string") {
        return size;
      }
      return "".concat(size / htmlFontSize * factor, "rem");
    }
  });
};
export { makeTypography };